const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StoreCustomerManagementCommand: any = {
    updateGlobalCustomerByPhone: Backofficebff + '/v1/customer/update-global-customer-by-phone',
};
